export default __webpack_public_path__ + "static/media/widget_watchbox_vpmnq60f_buy.f4dec4c4.mp3";